import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {
  CelebrateLine,
  CommentLine,
  GratitudeLine,
  InfoLine,
  OutOfOfficeLine,
  PersonCircleLine,
  PulseLine,
  TargetLine,
  WorkstreamsLine,
} from '@dropbox/dig-icons/assets';
import {NotificationCard} from 'components/notifications/NotificationCard';
import {useNotificationContext} from 'components/notifications/utils/useNotificationContext';
import {DueIn, TimeAgo} from 'components/shared/TimeAgo';
import {parseISO} from 'date-fns';
import {t} from 'i18next';
import {Trans} from 'react-i18next';

const iconMap = {
  gratitude: GratitudeLine,
  birthday: CelebrateLine,
  profile: PersonCircleLine,
  okr: TargetLine,
  generic: InfoLine,
  workstream: WorkstreamsLine,
  pulse: PulseLine,
  ooo: OutOfOfficeLine,
};

export const GenericNotification = () => {
  const {
    archiveable,
    upcoming,
    notification: {data: notification, archived, updated_at, due_at},
  } = useNotificationContext();
  const {content, to, icon, cta, data} = notification;
  const i18nKey =
    icon === 'birthday'
      ? upcoming
        ? 'notification_upcoming_birthday'
        : 'notification_birthday'
      : content;

  return (
    <NotificationCard
      accessory={
        <UIIcon
          src={
            Object.keys(iconMap).includes(icon)
              ? iconMap[icon as keyof typeof iconMap]
              : CommentLine
          }
          className={atoms({color: 'Text Subtle'})}
        />
      }
      header={<Trans i18nKey={i18nKey} t={t} values={{data}} components={{b: <Text isBold />}} />}
      subtext={
        upcoming || archived ? (
          Intl.DateTimeFormat('en-US', {
            weekday: !archived ? 'short' : undefined,
            day: 'numeric',
            month: 'short',
          }).format(parseISO(due_at ?? updated_at))
        ) : due_at ? (
          <DueIn timestamp={due_at} />
        ) : (
          <TimeAgo timestamp={updated_at} />
        )
      }
      to={to}
      archived={archived}
      buttonLink={!archived && !archiveable && !upcoming ? {to, cta} : undefined}
    />
  );
};
